/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BookingDTO } from '../model';
// @ts-ignore
import { CreateBookingOutputDTO } from '../model';
// @ts-ignore
import { HTTPValidationError } from '../model';
// @ts-ignore
import { UpdateBookingOutputDTO } from '../model';
// @ts-ignore
import { WriteBookingRequest } from '../model';
/**
 * BookingApi - axios parameter creator
 * @export
 */
export const BookingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create Booking
         * @param {WriteBookingRequest} writeBookingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingDockschedulingBookingsPost: async (writeBookingRequest: WriteBookingRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'writeBookingRequest' is not null or undefined
            assertParamExists('createBookingDockschedulingBookingsPost', 'writeBookingRequest', writeBookingRequest)
            const localVarPath = `/dockscheduling/bookings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete Booking
         * @param {string} bookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookingDockschedulingBookingsBookingIdDelete: async (bookingId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('deleteBookingDockschedulingBookingsBookingIdDelete', 'bookingId', bookingId)
            const localVarPath = `/dockscheduling/bookings/{booking_id}`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export bookings to an Excel file.
         * @summary Export Bookings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBookingsDockschedulingBookingsExportGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dockscheduling/bookings/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get Booking
         * @param {string} bookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingDockschedulingBookingsBookingIdGet: async (bookingId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('getBookingDockschedulingBookingsBookingIdGet', 'bookingId', bookingId)
            const localVarPath = `/dockscheduling/bookings/{booking_id}`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary List Bookings
         * @param {Array<string> | null} [dockIds]
         * @param {string | null} [bookingStartDate]
         * @param {string | null} [bookingEndDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBookingsDockschedulingBookingsGet: async (dockIds?: Array<string> | null, bookingStartDate?: string | null, bookingEndDate?: string | null, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dockscheduling/bookings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dockIds !== undefined) {
                localVarQueryParameter['dock_ids'] = dockIds;
            }

            if (bookingStartDate !== undefined) {
                localVarQueryParameter['booking_start_date'] = bookingStartDate;
            }

            if (bookingEndDate !== undefined) {
                localVarQueryParameter['booking_end_date'] = bookingEndDate;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update Booking
         * @param {string} bookingId
         * @param {WriteBookingRequest} writeBookingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBookingDockschedulingBookingsBookingIdPut: async (bookingId: string, writeBookingRequest: WriteBookingRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('updateBookingDockschedulingBookingsBookingIdPut', 'bookingId', bookingId)
            // verify required parameter 'writeBookingRequest' is not null or undefined
            assertParamExists('updateBookingDockschedulingBookingsBookingIdPut', 'writeBookingRequest', writeBookingRequest)
            const localVarPath = `/dockscheduling/bookings/{booking_id}`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingApi - functional programming interface
 * @export
 */
export const BookingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create Booking
         * @param {WriteBookingRequest} writeBookingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBookingDockschedulingBookingsPost(writeBookingRequest: WriteBookingRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBookingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBookingDockschedulingBookingsPost(writeBookingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete Booking
         * @param {string} bookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBookingDockschedulingBookingsBookingIdDelete(bookingId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBookingDockschedulingBookingsBookingIdDelete(bookingId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Export bookings to an Excel file.
         * @summary Export Bookings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportBookingsDockschedulingBookingsExportGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportBookingsDockschedulingBookingsExportGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get Booking
         * @param {string} bookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingDockschedulingBookingsBookingIdGet(bookingId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingDockschedulingBookingsBookingIdGet(bookingId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary List Bookings
         * @param {Array<string> | null} [dockIds]
         * @param {string | null} [bookingStartDate]
         * @param {string | null} [bookingEndDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBookingsDockschedulingBookingsGet(dockIds?: Array<string> | null, bookingStartDate?: string | null, bookingEndDate?: string | null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBookingsDockschedulingBookingsGet(dockIds, bookingStartDate, bookingEndDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update Booking
         * @param {string} bookingId
         * @param {WriteBookingRequest} writeBookingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBookingDockschedulingBookingsBookingIdPut(bookingId: string, writeBookingRequest: WriteBookingRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateBookingOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBookingDockschedulingBookingsBookingIdPut(bookingId, writeBookingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BookingApi - factory interface
 * @export
 */
export const BookingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingApiFp(configuration)
    return {
        /**
         *
         * @summary Create Booking
         * @param {WriteBookingRequest} writeBookingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingDockschedulingBookingsPost(writeBookingRequest: WriteBookingRequest, options?: any): AxiosPromise<CreateBookingOutputDTO> {
            return localVarFp.createBookingDockschedulingBookingsPost(writeBookingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Booking
         * @param {string} bookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookingDockschedulingBookingsBookingIdDelete(bookingId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteBookingDockschedulingBookingsBookingIdDelete(bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Export bookings to an Excel file.
         * @summary Export Bookings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportBookingsDockschedulingBookingsExportGet(options?: any): AxiosPromise<any> {
            return localVarFp.exportBookingsDockschedulingBookingsExportGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Booking
         * @param {string} bookingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingDockschedulingBookingsBookingIdGet(bookingId: string, options?: any): AxiosPromise<BookingDTO> {
            return localVarFp.getBookingDockschedulingBookingsBookingIdGet(bookingId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Bookings
         * @param {Array<string> | null} [dockIds]
         * @param {string | null} [bookingStartDate]
         * @param {string | null} [bookingEndDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBookingsDockschedulingBookingsGet(dockIds?: Array<string> | null, bookingStartDate?: string | null, bookingEndDate?: string | null, options?: any): AxiosPromise<Array<BookingDTO>> {
            return localVarFp.listBookingsDockschedulingBookingsGet(dockIds, bookingStartDate, bookingEndDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Booking
         * @param {string} bookingId
         * @param {WriteBookingRequest} writeBookingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBookingDockschedulingBookingsBookingIdPut(bookingId: string, writeBookingRequest: WriteBookingRequest, options?: any): AxiosPromise<UpdateBookingOutputDTO> {
            return localVarFp.updateBookingDockschedulingBookingsBookingIdPut(bookingId, writeBookingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingApi - object-oriented interface
 * @export
 * @class BookingApi
 * @extends {BaseAPI}
 */
export class BookingApi extends BaseAPI {
    /**
     *
     * @summary Create Booking
     * @param {WriteBookingRequest} writeBookingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public createBookingDockschedulingBookingsPost(writeBookingRequest: WriteBookingRequest, options?: any) {
        return BookingApiFp(this.configuration).createBookingDockschedulingBookingsPost(writeBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete Booking
     * @param {string} bookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public deleteBookingDockschedulingBookingsBookingIdDelete(bookingId: string, options?: any) {
        return BookingApiFp(this.configuration).deleteBookingDockschedulingBookingsBookingIdDelete(bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export bookings to an Excel file.
     * @summary Export Bookings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public exportBookingsDockschedulingBookingsExportGet(options?: any) {
        return BookingApiFp(this.configuration).exportBookingsDockschedulingBookingsExportGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get Booking
     * @param {string} bookingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public getBookingDockschedulingBookingsBookingIdGet(bookingId: string, options?: any) {
        return BookingApiFp(this.configuration).getBookingDockschedulingBookingsBookingIdGet(bookingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary List Bookings
     * @param {Array<string> | null} [dockIds]
     * @param {string | null} [bookingStartDate]
     * @param {string | null} [bookingEndDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public listBookingsDockschedulingBookingsGet(dockIds?: Array<string> | null, bookingStartDate?: string | null, bookingEndDate?: string | null, options?: any) {
        return BookingApiFp(this.configuration).listBookingsDockschedulingBookingsGet(dockIds, bookingStartDate, bookingEndDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update Booking
     * @param {string} bookingId
     * @param {WriteBookingRequest} writeBookingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingApi
     */
    public updateBookingDockschedulingBookingsBookingIdPut(bookingId: string, writeBookingRequest: WriteBookingRequest, options?: any) {
        return BookingApiFp(this.configuration).updateBookingDockschedulingBookingsBookingIdPut(bookingId, writeBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
